<template>
  <div
    class="wrap"
    :class="{
      text: presentation.type === 'text',
      image: presentation.type === 'image',
      html: presentation.type === 'html',
      tag: presentation.type === 'tag',
      'has-option': question.audio || question.video,
    }"
    :style="{ height: blockHeight }"
  >
    <div
      class="box-contents"
      @touchstart="dragStart"
      @mousedown="dragStart"
      :style="{
        transform: `translateX(${dragPosition}px)`,
      }"
    >
      <transition :name="transitionName">
        <div class="contents-wrap" :key="`cw${now}`">
          <div
            class="q-option-container"
            ref="optionBlock"
            v-if="question.audio || question.video"
          >
            <img
              src="@/assets/img/btn_sound.png"
              v-if="question.audio"
              :key="`audio${question.audio}`"
              class="q-btn_sound q-option"
              alt="音声"
              @click="openAudioModal"
              @touchstart="openAudioModal"
              width="113"
              height="58"
            />
            <img
              src="@/assets/img/btn_movie.png"
              v-if="question.video"
              :key="`video${question.video}`"
              class="q-btn_movie q-option"
              alt="動画"
              @click="openVideoModal"
              @touchstart="openVideoModal"
              width="113"
              height="58"
            />
          </div>
          <TextBlock
            class="presentation"
            :class="{
              'has-option': question.video || question.audio,
            }"
            :hasOption="question.audio || question.video ? true : false"
            v-if="init && presentation.type === 'text'"
            :question="question"
            :optionBlockHeight="optionBlockHeight"
            @blockSize="setBlockSize"
            :key="`presentation${now}`"
          />
          <iframe
            class="presentation"
            :class="{
              'has-option': question.video || question.audio,
            }"
            v-else-if="init && presentation.type === 'html'"
            :src="`${setting.path}${presentation.value}`"
            @load="iframeLoaded"
            :key="`presentation${now}`"
          ></iframe>
          <imgSwipe
            class="presentation"
            :class="{
              'has-option': question.video || question.audio,
            }"
            :src="`${setting.path}${presentation.value}`"
            :hasOption="question.audio || question.video ? true : false"
            v-else-if="init && presentation.type === 'image'"
            @blockSize="setBlockSize"
            :key="`presentation${now}`"
          />
          <TagArea
            class="presentation"
            :class="{
              'has-option': question.video || question.audio,
            }"
            v-else-if="init && presentation.type === 'tag'"
            :value="`${setting.path}${presentation.value}`"
            :tags="presentation.tags"
            :key="`presentation${now}`"
            @blockSize="setBlockSize"
            :hasOption="question.audio || question.video ? true : false"
          ></TagArea>
        </div>
      </transition>
    </div>

    <AudioModal
      v-if="isAudioModalOpen"
      :src="`${setting.path}${question.audio}`"
      :config="config"
      :id="`q_${question.audio}`"
      title="音声"
      @closemodal="isAudioModalOpen = false"
    />
    <VideoModal
      v-if="isVideoModalOpen"
      :src="`${setting.path}${question.video}`"
      :config="config"
      title="動画"
      @closemodal="isVideoModalOpen = false"
    />
  </div>
</template>

<script>
/* eslint-disable no-console */
import VideoModal from "@/components/questionPages/Question/parts/Modal/videoModal.vue";
import AudioModal from "@/components/questionPages/Question/parts/Modal/audioModal.vue";

import TextBlock from "./Presentation/textArea.vue";
import TagArea from "./Presentation/tagArea.vue";
import ImgSwipe from "./Presentation/imgSwipe.vue";

export default {
  props: ["now"],
  components: { TagArea, ImgSwipe, TextBlock, VideoModal, AudioModal },
  data() {
    return {
      init: false,
      transitionName: "prev",
      blockHeight: "100%",
      optionBlockSize: 0,

      dragging: false,
      initPosition: { x: 0, y: 0 },
      dragPosition: 0,
      isAudioModalOpen: false,
      isVideoModalOpen: false,
      transition: false
    };
  },
  mounted() {
    this.optionBlockHeight = this.$refs.optionBlock
      ? this.$refs.optionBlock.clientHeight
      : 0;
    console.log(this.optionBlockHeight);

    this.init = true;
  },
  computed: {
    presentation() {
      return this.question.presentation;
    },
    mode() {
      return this.$store.state.mode;
    },
    drills() {
      return this.$store.state.drills;
    },
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    questions() {
      return this.drill.questions;
    },
    list() {
      return this.$store.getters.list;
    },
    question() {
      return this.$store.getters.question;
    }
  },
  methods: {
    setBlockSize(value) {
      console.log("setBlockSize", value);
      if (!value) {
        this.blockHeight = "auto";
        return;
      }
      this.blockHeight = value;
    },
    iframeLoaded() {
      this.blockHeight = "100%";
    },
    openVideoModal() {
      this.isVideoModalOpen = true;
    },
    openAudioModal() {
      console.log('audioModal Open')
      this.isAudioModalOpen = true;
    },
    dragStart(e) {
      if (this.mode === 'end') {
        return;
      }

      if (
        e.target.className.indexOf("pswp") === -1 &&
        e.target.className.indexOf("q-option") === -1 &&
        e.target.className.indexOf("tag") === -1 &&
        e.target.className.indexOf("clear-sets") === -1 &&
        e.target.className.indexOf("q-option-container") === -1
      ) {
        if (
          e.target.className.indexOf("text-block") === -1 &&
          e.target.className.indexOf("img-wrap") === -1 &&
          e.target.className.indexOf("view") === -1
        ) {
          console.log("prev");
          e.preventDefault();
        }
        console.log("drag start");
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        this.initPosition = { x: point.pageX, y: point.pageY };
        window.addEventListener("touchmove", this.dragMove, { passive: false });
        window.addEventListener("mousemove", this.dragMove, { passive: false });

        window.addEventListener("touchend", this.dragEnd, { passive: false });
        window.addEventListener("mouseup", this.dragEnd, { passive: false });
      } else {
        console.log('return')
        return;
      }
    },
    dragMove(e) {
      if (this.dragging) {
        if (
          e.target.className.indexOf("text-block") === -1 &&
          e.target.className.indexOf("img-wrap") === -1 &&
          e.target.className.indexOf("view") === -1
        ) {
          console.log("pv");
          e.preventDefault();
        } else {
          console.log("not pv");
        }
        // console.log("dragging");
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        this.dragPosition = point.pageX - this.initPosition.x;
        const goUp = point.pageY - this.initPosition.y > 0;
        console.log(goUp);
        if (this.$refs["textWrap"]) {
          const wrapScrollPosY = this.$refs["textWrap"].scrollTop;
          if (wrapScrollPosY === 0 && goUp) {
            console.log("pv");
            e.preventDefault();
          } else {
            console.log("not pv");
          }
        }
        // console.log(this.position);
      }
    },
    dragEnd(e) {
      if (this.dragging) {
        e.preventDefault();
        // console.log("dragEnd");
        this.dragging = false;

        const threshold = window.innerWidth / 5;

        if (this.dragPosition > threshold) {
          this.prev();
        } else if (this.dragPosition < threshold * -1) {
          this.next();
        }

        this.dragPosition = 0;
      }

      window.removeEventListener("touchmove", this.dragMove);
      window.removeEventListener("mousemove", this.dragMove);

      window.removeEventListener("touchend", this.dragEnd);
      window.removeEventListener("mouseup", this.dragEnd);
    },
    next() {
      this.$emit("next");
    },
    prev() {
      this.$emit("prev");
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    }
  },
  watch: {
    now(nv, pv) {
      console.warn("now", pv, nv);
      if (nv > pv) {
        this.transitionName = "next";
      } else {
        this.transitionName = "prev";
      }
      console.log(this.transitionName);
      this.transition = true;
      this.dragPosition = 0;
      this.isAudioModalOpen = false;
      this.isVideoModalOpen = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.transition = false;
        }, 1000);
      });
    },
    isAudioModalOpen(nv) {
      if (this.transition) {
        return;
      }

      if (nv) {
        this.$emit('pauseTimer');
        return
      }
      this.$emit('resumeTimer');
    },
    isVideoModalOpen(nv) {
      if (this.transition) {
        return;
      }
      if (nv) {
        this.$emit('pauseTimer');
        return
      }
      this.$emit('resumeTimer');
    },
  }
};
</script>

<style scoped>
.wrap {
  width: calc(100% - 88px);
  flex: 1 0 calc(100% - 88px);
  position: relative;
}

.wrap.text {
  /*  max-height: 15em; */
  height: 100%;
  max-height: 100%;
}

.wrap.html:before,
.wrap.image:before {
  content: "";
  display: block;
  padding-top: calc(97.5% - 140px); /* 高さを幅の75%に固定 */
}

.wrap.tag:before {
  content: "";
  display: block;
  padding-top: calc(100% - 140px);
}

.wrap.tag:before {
  padding-bottom: 0px;
}

.has-option.wrap:before {
  padding-bottom: 60px;
}

.has-option.wrap.tag:before {
  padding-bottom: 72px;
}

.wrap > .box-contents {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  /*
  display: flex;
  justify-content: center;
  align-items: center;
  */
}

.contents-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  flex-basis: 100%;
}

.presentation {
  width: 100%;
  height: 100%;

  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  overflow: auto;

  touch-action: pan-y;
}

.presentation.has-option {
  height: calc(100% - 60px);
}

.disabled {
  opacity: 0.3;
}

.prev-enter-active,
.prev-leave-active,
.next-enter-active,
.next-leave-active {
  transform: translateX(0);
  transition: all 0.5s;
}
.prev-leave-to,
.next-enter {
  opacity: 0;
  transform: translateX(200px);
}

.prev-enter,
.next-leave-to {
  opacity: 0;
  transform: translateX(-200px);
}

.q-option-container {
  text-align: right;
  height: 58px;
}
</style>
